import React from 'react';
export function ExpertSection() {
  return <section className="w-full bg-bg-dark py-20 px-4" data-id="element-68">
      <div className="max-w-3xl mx-auto text-center" data-id="element-69">
        <div className="text-4xl sm:text-5xl mb-6" data-id="element-70">🎨</div>

        <h2 className="text-3xl sm:text-4xl font-serif font-black text-text-main mb-6" data-id="element-71">
          Sobre Arte Lista
        </h2>

        <p className="text-text-sec text-lg sm:text-xl leading-relaxed font-medium max-w-2xl mx-auto" data-id="element-72">
          Nacimos con una misión clara: devolverle el tiempo y la paz mental a
          los docentes de Arte en todo el mundo hispanohablante. Sabemos lo que
          es preparar clases a las 11 de la noche sin saber qué actividad dar
          mañana. Arte Lista es el sistema que nos hubiera gustado tener cuando
          empezamos.
        </p>
      </div>
    </section>;
}